import React from "react";
import PropTypes from "prop-types";
import { Col, Figure, Row } from "react-bootstrap";

export default function Image(props) {
  return (
    <Row className="my-4">
      {props.size === "small" && (
        <Col md={{ span: 4, offset: 4 }}>
          {props.imgUrl && (
            <Figure>
              <Figure.Image fluid alt={props.alt} src={props.imgUrl} />
              {props.caption && (
                <Figure.Caption>{props.caption}</Figure.Caption>
              )}
            </Figure>
          )}
        </Col>
      )}
      {props.size === "medium" && (
        <Col md={{ span: 8, offset: 2 }}>
          {props.imgUrl && (
            <Figure>
              <Figure.Image fluid alt={props.alt} src={props.imgUrl} />
              {props.caption && (
                <Figure.Caption>{props.caption}</Figure.Caption>
              )}
            </Figure>
          )}
        </Col>
      )}
      {props.size === "large" && (
        <Col md={{ span: 12 }}>
          {props.imgUrl && (
            <Figure>
              <Figure.Image fluid alt={props.alt} src={props.imgUrl} />
              {props.caption && (
                <Figure.Caption>{props.caption}</Figure.Caption>
              )}
            </Figure>
          )}
        </Col>
      )}
    </Row>
  );
}

Image.propTypes = {
  size: PropTypes.string,
  imgUrl: PropTypes.string,
  alt: PropTypes.string,
  caption: PropTypes.string,
};

Image.defaultProps = {
  size: "small",
};
